import { getSceneActions, getSceneState } from "../../stores/sceneStore";

const removeNamedCameras = (sceneActions, sceneState, cameraNames = []) => {
  const targetNames = new Set(cameraNames.map((name) => String(name || "").trim()).filter(Boolean));
  Object.values(sceneState.cameras || {})
    .filter((camera) => targetNames.has(String(camera?.name || "").trim()))
    .forEach((camera) => {
      if (camera?.uuid) {
        sceneActions.removeCamera(camera.uuid);
      }
    });
};

const applyUr5ePickAndPlaceCameras = () => {
  const sceneActions = getSceneActions();
  const sceneStateAfterLoad = getSceneState();
  removeNamedCameras(sceneActions, sceneStateAfterLoad, ["primary", "wrist"]);

  sceneActions.addCamera({
    name: "primary",
    kind: "fixed",
    position: [-0.3103, 1.4638, 0.9041],
    orientation: [
      0.8944908346926562, -0.43838108453988733, -0.0582088104339458, 0.06572598996083916,
    ],
    fovy: 65,
  });

  const bodies = sceneStateAfterLoad.bodies || {};
  const sites = sceneStateAfterLoad.sites || {};
  const gripperTargetSiteUuid = Object.values(sites).find(
    (site) => site?.name === "gripper_target"
  )?.uuid;
  const gripperBaseBodyUuid = gripperTargetSiteUuid
    ? Object.values(bodies).find(
        (body) => Array.isArray(body?.sites) && body.sites.includes(gripperTargetSiteUuid)
      )?.uuid
    : null;
  const preferredWristBodyNameRegexes = [
    /^wrist_3_link$/i,
    /^tool0$/i,
    /^ee_link$/i,
    /^gripper_base$/i,
    /^hand$/i,
    /wrist/i,
    /gripper/i,
    /tool/i,
    /\bee\b/i,
    /hand/i,
  ];
  const bodyEntries = Object.values(bodies);
  const inferredWristBodyUuid =
    preferredWristBodyNameRegexes
      .map((regex) => bodyEntries.find((body) => regex.test(body?.name || ""))?.uuid)
      .find(Boolean) || null;
  const wristMountBodyUuid = gripperBaseBodyUuid || inferredWristBodyUuid;

  if (wristMountBodyUuid) {
    sceneActions.addCamera({
      name: "wrist",
      kind: "mounted",
      mountType: "body",
      mountBodyUuid: wristMountBodyUuid,
      position: [0, 0.08, 0],
      orientation: [-0.21643961393810282, 0.9762960071199335, 0, 0],
      fovy: 65,
    });
  }
};

const applyTrossenPickAndPlaceCameras = () => {
  const sceneActions = getSceneActions();
  const sceneStateAfterLoad = getSceneState();
  removeNamedCameras(sceneActions, sceneStateAfterLoad, ["primary", "wrist"]);

  const sites = sceneStateAfterLoad.sites || {};
  const gripperTargetSiteUuid = Object.values(sites).find(
    (site) => site?.name === "gripper_target"
  )?.uuid;

  if (gripperTargetSiteUuid) {
    sceneActions.addCamera({
      name: "wrist",
      kind: "mounted",
      mountType: "site",
      mountSiteUuid: gripperTargetSiteUuid,
      position: [-0.0733, 0.0, 0.0413],
      orientation: [
        0.6417231216503952, 0.2969704280551721, -0.295476641519321, -0.6424122930925767,
      ],
      fovy: 65,
      width: 256,
      height: 256,
      fps: 8,
    });
  }

  sceneActions.addCamera({
    name: "primary",
    kind: "fixed",
    position: [0.186, 0.352, 0.862],
    orientation: [
      0.9932789246695279, -0.10790462192185483, 0.04163072152185469, -0.004522543622522072,
    ],
    fovy: 65,
    width: 256,
    height: 256,
    fps: 8,
  });
};

export const CAMERA_PRESET_HANDLERS = {
  ur5ePickAndPlace: applyUr5ePickAndPlaceCameras,
  trossenPickAndPlace: applyTrossenPickAndPlaceCameras,
};
